<template>
  <div class="button-group">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.button-group {
  display: flex;
  & > .button {
    width: 100%;
    &:not(:first-child) {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: 1em;
    }
    &:not(:last-child) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      padding-right: 1em;
      margin-right: 1px;
    }
    &:hover {
      z-index: 2;
    }
  }
}
</style>
